import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Colors from "Constants/Color";
import { DETAILS_BG, tableStyles } from "Constants/Style";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import LoadingSpinner from "components/LoaderErrorWrapper/LoadingSpinner";
import PageContainer from "components/PageContainer/PageContainer";
import TruncatedTextCell from "components/TruncatedTextCell/TruncatedTextCell";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { createSelector } from "reselect";
import { fetchQuotationById } from "slices/quotation/thunk";
import QuotationViewBagsModal from "./Form/QuotationForm/QuotationViewBagsModal";
import CancelBackButton from "components/Buttons/CancelBackButton";

const QuotationDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const [showViewBagsModal, setShowViewBagsModal] = useState(false);
  const [viewBagsForItem, setViewBagsForItem] = useState<any[]>([]);

  // Redux selector for quotation state
  const selectQuotationData = createSelector(
    (state: any) => state.Quotation,
    (quotation) => ({
      selectedQuotation: quotation.selectedQuotation,
      loading: quotation.loading,
      error: quotation.error,
    })
  );

  const { selectedQuotation, loading, error } =
    useSelector(selectQuotationData);

  // Fetch quotation data using Redux thunk
  useEffect(() => {
    if (!id) {
      toast.error("Quotation ID is missing");
      navigate("/quotation");
      return;
    }

    // Dispatch thunk to fetch quotation by ID
    dispatch(fetchQuotationById(id));
  }, [id, dispatch, navigate]);

  // Handle errors
  // useEffect(() => {
  //   if (error) {
  //     toast.error(error);
  //     navigate("/quotation");
  //   }
  // }, [error, navigate]);

  const handleCancel = () => {
    navigate("/quotation");
  };

  const formatDate = (date: string | null | undefined) => {
    if (!date) return "—";
    return moment(date).format("DD/MM/YYYY");
  };

  // if (!selectedQuotation) {
  //   return (
  //     <div className="page-content px-4">
  //       <div className="text-center py-5 bg-white rounded-3 shadow-sm">
  //         <p>No quotation data found</p>
  //         <Button variant="primary" onClick={handleCancel}>
  //           Back to Quotation List
  //         </Button>
  //       </div>
  //     </div>
  //   );
  // }

  const quotationData = selectedQuotation;

  return (
    <PageContainer>
      <Card.Header>
        <FormHeader
          title="View Quotation"
          firstLabel="Quotation"
          secondLabel="Quotation details"
          handleArrowClick={() => navigate("/quotation")}
        />
      </Card.Header>

      <hr />
      {loading ? (
        <LoadingSpinner />
      ) : !selectedQuotation ? (
        <div className="text-center py-5 bg-white rounded-3 shadow-sm">
          <p>No quotation data found</p>
          <Button variant="primary" onClick={handleCancel}>
            Back to Quotation List
          </Button>
        </div>
      ) : (
        <Card.Body>
          {/* Quotation Details */}
          <Row className="mb-3">
            <div>
              <h6 className="card-title mb-4 mt-3">Quotation Details</h6>
            </div>

            <Col xs={12} md={6} lg={4}>
              <p className="mb-3">
                <strong>Quotation No.:</strong>{" "}
                {quotationData?.quotation_number || "—"}
              </p>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <p className="mb-3">
                <strong>Quotation Date:</strong>{" "}
                {formatDate(quotationData?.quotation_date)}
              </p>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <p className="mb-3">
                <strong>Enquiry No:</strong>{" "}
                {quotationData?.enquiry?.enquiry_number ||
                  quotationData?.enquiry_number ||
                  "—"}
              </p>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <p className="mb-3">
                <strong>Dispatch From Warehouse: </strong>{" "}
                {quotationData?.warehouse?.warehouse_name || "—"}
              </p>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <p className="mb-3">
                <strong>Stage:</strong>{" "}
                <span className="badge inline px-3 py-2 rounded-pill bg-light text-dark">
                  {quotationData?.stage || "Pending"}
                </span>
              </p>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <p className="mb-3">
                <strong>Remark:</strong> {quotationData?.remarks || "—"}
              </p>
            </Col>
          </Row>

          <hr />

          {/* Customer Details */}
          <Row className="mb-3">
            <div>
              <h6 className="card-title mb-3 mt-3">Customer Details</h6>
            </div>

            <div
              style={{
                backgroundColor: `${Colors?.background_color}`,
                padding: "0 20px",
                borderRadius: "8px",
                border: `1px solid ${Colors?.background_color}`,
              }}
            >
              <Row className="mb-0 mt-3">
                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Customer Name :</strong>{" "}
                    {quotationData?.customer_details?.customer_name || "—"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Customer Type :</strong>{" "}
                    {quotationData?.customer_details?.customer_type || "—"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>GSTIN :</strong>{" "}
                    {quotationData?.customer_details?.gstin || "—"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Email :</strong>{" "}
                    {quotationData?.customer_details?.email || "—"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Phone Number :</strong>{" "}
                    {quotationData?.customer_details?.contact_number ||
                      quotationData?.customer_details?.phone_number ||
                      "—"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Aadhar No. :</strong>{" "}
                    {quotationData?.customer_details?.aadhar_no
                      ? `xxxx xxxx ${quotationData.customer_details.aadhar_no.slice(
                          -2
                        )}`
                      : "—"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Address :</strong>{" "}
                    {[
                      quotationData?.customer_details?.address,
                      quotationData?.customer_details?.city,
                      quotationData?.customer_details?.pincode,
                    ]
                      .filter(Boolean)
                      .join(", ") || "—"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Contact Person Name :</strong>{" "}
                    {quotationData?.customer_details?.contact_person_name ||
                      "—"}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Contact Person No. :</strong>{" "}
                    {quotationData?.customer_details
                      ?.contact_person_mobile_no ||
                      quotationData?.customer_details
                        ?.contact_person_phone_no ||
                      "—"}
                  </p>
                </Col>
              </Row>
            </div>
          </Row>

          <hr />

          {/* Financial Summary */}
          <Row className="mb-3">
            <div>
              <h6 className="card-title mb-4 mt-3">Financial Summary</h6>
            </div>

            <div className="">
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Subtotal (Before Discount) :</strong>&nbsp; ₹{" "}
                    {parseFloat(
                      quotationData?.subtotal_before_discount || "0"
                    ).toFixed(2)}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Total Item Discounts :</strong>&nbsp; ₹{" "}
                    {parseFloat(
                      quotationData?.total_item_discounts || "0"
                    ).toFixed(2)}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Net Taxable Value :</strong>&nbsp; ₹{" "}
                    {parseFloat(
                      quotationData?.net_taxable_value || "0"
                    ).toFixed(2)}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong>Total GST :</strong>&nbsp; ₹{" "}
                    {parseFloat(quotationData?.total_gst || "0").toFixed(2)}
                  </p>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <p className="mb-3">
                    <strong className="fs-5">Total Amount :</strong>&nbsp;
                    <span className="fs-5 fw-bold">
                      ₹{" "}
                      {parseFloat(quotationData?.total_amount || "0").toFixed(
                        2
                      )}
                    </span>
                  </p>
                </Col>
              </Row>
            </div>
          </Row>

          <hr />

          {/* Item Details */}
          {quotationData?.quotation_items &&
            quotationData.quotation_items.length > 0 && (
              <>
                <Row className="mb-3">
                  <p>
                    <h6 className="card-title mb-0 mt-3">Item Details</h6>
                  </p>
                  <Col md={12}>
                    <Table
                      hover
                      responsive
                      className="align-middle text-center"
                    >
                      <thead style={{ backgroundColor: "#e3f2fd" }}>
                        <tr>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "70px",
                              padding: "12px",
                            }}
                          >
                            Sr. No.
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "150px",
                              padding: "12px",
                            }}
                          >
                            Category
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "150px",
                              padding: "12px",
                            }}
                          >
                            Sub Category
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "150px",
                              padding: "12px",
                            }}
                          >
                            Item Name
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "120px",
                              padding: "12px",
                            }}
                          >
                            Item Code
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "100px",
                              padding: "12px",
                            }}
                          >
                            Unit
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "180px",
                              padding: "12px",
                            }}
                          >
                            Required Quantity
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "100px",
                              padding: "12px",
                            }}
                          >
                            Bags
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "120px",
                              padding: "12px",
                            }}
                          >
                            Selling Price
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "120px",
                              padding: "12px",
                            }}
                          >
                            Amount
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "100px",
                              padding: "12px",
                            }}
                          >
                            Discount
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "180px",
                              padding: "12px",
                            }}
                          >
                            Discount Amount
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "100px",
                              padding: "12px",
                            }}
                          >
                            GST %
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "120px",
                              padding: "12px",
                            }}
                          >
                            GST Amount
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "120px",
                              padding: "12px",
                            }}
                          >
                            Total Amount
                          </th>
                          <th
                            style={{
                              ...tableStyles.headerAlt,
                              minWidth: "150px",
                              padding: "12px",
                            }}
                          >
                            Remarks
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {quotationData.quotation_items.map(
                          (item: any, index: number) => (
                            <tr
                              key={item.quotation_item_id || index}
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "#ffffff" : "#e3f2fd",
                              }}
                            >
                              <td style={{ padding: "12px" }}>{index + 1}</td>
                              <td style={{ padding: "12px" }}>
                                {item.category_name || "—"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {item.sub_category_name || "—"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {item.item_name || "—"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {item.item_code || "—"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {item.unit_name || item.unit || "—"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {item.required_quantity || item.quantity || "—"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {item?.bags && item.bags.length > 0 ? (
                                  <VisibilityOutlinedIcon
                                    style={{
                                      color: Colors?.bg_blue,
                                      cursor: "pointer",
                                      fontSize: "1.5rem",
                                    }}
                                    onClick={() => {
                                      setViewBagsForItem(item.bags);
                                      setShowViewBagsModal(true);
                                    }}
                                  />
                                ) : (
                                  "—"
                                )}
                              </td>
                              <td style={{ padding: "12px" }}>
                                ₹{" "}
                                {parseFloat(
                                  item.selling_price || item.rate || "0"
                                ).toFixed(2)}
                              </td>
                              <td style={{ padding: "12px" }}>
                                ₹ {parseFloat(item.amount || "0").toFixed(2)}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {item.discount && parseFloat(item.discount) > 0
                                  ? item.discount_type === "percentage" ||
                                    item.discount_type === "%"
                                    ? `${parseFloat(item.discount).toFixed(2)}%`
                                    : item.discount_type === "amount" ||
                                      item.discount_type === "₹"
                                    ? `₹ ${parseFloat(item.discount).toFixed(
                                        2
                                      )}`
                                    : `${parseFloat(item.discount).toFixed(2)}`
                                  : "—"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {(() => {
                                  const discountType = item.discount_type;
                                  const discount = parseFloat(
                                    item.discount || "0"
                                  );
                                  const amount = parseFloat(item.amount || "0");
                                  let calculatedDiscountAmount = 0;

                                  if (discount > 0) {
                                    if (
                                      discountType === "percentage" ||
                                      discountType === "%"
                                    ) {
                                      calculatedDiscountAmount =
                                        (amount * discount) / 100;
                                    } else if (
                                      discountType === "amount" ||
                                      discountType === "₹"
                                    ) {
                                      calculatedDiscountAmount = discount;
                                    } else {
                                      // Fallback: use discount_amount if available, otherwise calculate as percentage
                                      calculatedDiscountAmount =
                                        parseFloat(
                                          item.discount_amount || "0"
                                        ) || (amount * discount) / 100;
                                    }
                                  } else {
                                    calculatedDiscountAmount = parseFloat(
                                      item.discount_amount || "0"
                                    );
                                  }

                                  return calculatedDiscountAmount > 0
                                    ? `₹ ${calculatedDiscountAmount.toFixed(2)}`
                                    : "—";
                                })()}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {item.gst_percent
                                  ? `${item.gst_percent}%`
                                  : "—"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                ₹{" "}
                                {parseFloat(item.gst_amount || "0").toFixed(2)}
                              </td>
                              <td style={{ padding: "12px" }}>
                                ₹{" "}
                                {parseFloat(item.total_amount || "0").toFixed(
                                  2
                                )}
                              </td>
                              <td className="remark-cell" style={{ padding: "12px" }}>
                                <TruncatedTextCell
                                  text={item.remarks || item.remark}
                                  maxWidth="300px"
                                  maxLines={4}
                                  rowIndex={index}
                                  fallbackText="—"
                                />
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <hr />
              </>
            )}

          <div className="d-flex flex-wrap justify-content-center gap-3 mt-5">
            <CancelBackButton to="/quotation" label="Back" />
          </div>
        </Card.Body>
      )}

      <QuotationViewBagsModal
        show={showViewBagsModal}
        handleClose={() => setShowViewBagsModal(false)}
        bags={viewBagsForItem}
      />
    </PageContainer>
  );
};

export default QuotationDetailsPage;
